import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import {Form,FormItem,Pagination} from 'element-ui'

export default {
    async install(Vue) {
        locale.use(lang)
        Vue.use(Form)
        Vue.use(FormItem)
        Vue.use(Pagination)
    }
}